import { Chip, styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import type { StyledStatusChipProps } from './types';

export const StyledChip = styled(Chip, {
  shouldForwardProp: prop =>
    !['fontSize', 'chipColor'].includes(prop.toString()),
})<StyledStatusChipProps>(({ fontSize, chipColor }) => ({
  backgroundColor: NEW_COLORS.SEMANTICS.ERROR[25],
  color: chipColor,
  fontWeight: 700,
  fontSize,
  borderColor: chipColor,
  padding: '4px 8px',
  maxWidth: 'fit-content',
  '.MuiChip-label': {
    padding: 0,
  },
}));
